/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Karol Pawlak <karolpawlak.giap@gmail.com>, January 2020
 */

/* eslint-disable max-len */
/* flow-disable */

import _ from 'lodash';
import React, { PropTypes } from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { connect } from 'react-redux';
import { runService } from '../../actions/eservices';
import PowrotDoListyEuslug from '../../components/PowrotDoListyEuslug/PowrotDoListyEuslug';
import { isMobileView, isTabletView, renderHelpDesc } from '../../components/utils/utils';
import EmptyFileDownloader from '../../components/EmptyFileDownloader/EmptyFileDownloader';
import { PersonalDataContainer, DecisionContainer } from '../../containers';
import history from '../../core/history';
import pans from './panStyle.scss';
import ModalAlert from './ModalAlert';
import CustomizedMap from './CustomizedMap';
import GrayPanel from '../../components/GrayPanel';
import v from './validators';
import fetch from '../../core/fetch/fetch.server';


const btnStyle = {
  borderRadius: 0,
  border: 'none',
  padding: '10px 40px',
  marginLeft: '10px',
};

const InfoTypeDict = {
  mapName: {
    label: 'Rodzaj mapy:',
    editable: true,
  },
  scale: {
    label: 'Skala:',
    editable: true,
  },
  colour: {
    label: 'Kolor, którym wskazano propozycję przebiegu drogi:',
    editable: true,
  },
  roadNr: {
    label: 'Numer drogi:',
    editable: true,
  },
};

const ParcelTypeDict = {
  parcelTown: {
    label: 'Miejscowość:',
    editable: true,
  },
  parcelStreet: {
    label: 'Ulica:',
    editable: true,
  },
  parcelMapNr: {
    label: 'Ark. mapy:',
    editable: true,
  },
  parcelDecNr: {
    label: 'Numer księgi wieczystej:',
    editable: true,
  },
};

const Parcel2TypeDict = {
  parcel2Town: {
    label: 'Miejscowość:',
    editable: true,
  },
  parcel2Street: {
    label: 'Ulica:',
    editable: true,
  },
  parcel2MapNr: {
    label: 'Ark. mapy:',
    editable: true,
  },
  parcel2DecNr: {
    label: 'Numer księgi wieczystej:',
    editable: true,
  },
};

class ObciazanieNieruchomosci extends React.Component {
  state = {
    info: {
      mapName: null,
      scale: null,
      colour: null,
      roadNr: null,
      parcelTown: null,
      parcelDecNr: null,
      parcelStreet: null,
      parcelMapNr: null,
      parcel2Town: null,
      parcel2Street: null,
      parcel2MapNr: null,
      parcel2DecNr: null,
    },
    selectedParcels: [],
    selectedParcels2: [],
    errors: {},
    errorTitle: '',
    errorText: '',
    showError: false,
    eserviceDistrict: null,
    isMounted: false,
  };

  validators = {
    mapName: [v.NotNull],
    scale: [v.NotNull],
    colour: [v.NotNull],
    roadNr: [v.NotNull],
    parcelTown: [v.NotNull],
    parcelDecNr: [v.NotNull],
    parcelStreet: [],
    parcelMapNr: [v.NotNull],
    parcel2Town: [v.NotNull],
    parcel2Street: [],
    parcel2MapNr: [v.NotNull],
    parcel2DecNr: [v.NotNull],
  };

  nextStep = '/eservices/eserviceSummary/';

  componentDidMount() {
    fetch(`${process.env.API_URL}/eservice/${this.props.district}/${this.props.query.serviceType}`)
      .then(r => r.json())
      .then(resp => {
        this.setState({
          eserviceDistrict: resp,
        });
      });

    this.setState({ isMounted: true });
  }

  onHide = () => this.setState({ showError: false });
  setParcels = (parcels, callback = null) => this.setState({ selectedParcels: parcels });
  setParcels2 = (parcels, callback = null) => this.setState({ selectedParcels2: parcels });

  onChange = (e, group) => {
    const name = e.target.name;
    this.setState(
      {
        [group]: {
          ...this.state[group],
          [name]: e.target.value,
        },
      },
      () => this.validate(group, name, this.calculateFields),
    );
  };

  validateField = (group, field) => {
    const checks = [];
    if (Object.keys(this.validators).indexOf(field) > -1) {
      for (const validator of this.validators[field]) {
        const check = validator(this.state[group][field]);
        if (check) checks.push(check);
      }
    }
    return checks;
  };

  validateGroup = group => {
    const fields = Object.keys(this.state[group]);
    const errors = {};
    for (const f of fields) {
      const checks = this.validateField(group, f);
      errors[f] = checks;
    }
    return errors;
  };

  validate = (group, field = null, callback = null) => {
    let newState = null;
    if (field) {
      if (Object.keys(this.validators).indexOf(field) > -1) {
        const checks = this.validateField(group, field);
        newState = {
          errors: {
            ...this.state.errors,
            [field]: checks,
          },
        };
      }
    } else if (group) {
      const errors = this.validateGroup(group);
      newState = { errors };
    } else {
      let errors = {};
      const grupy = ['info'];
      for (const g of grupy) {
        const err = this.validateGroup(g);
        errors = { ...errors, ...err };
      }
      newState = { errors: { ...errors } };
    }
    if (newState) {
      if (callback) {
        this.setState(newState, callback);
      } else {
        this.setState(newState);
      }
    }
  };

  haseErrors = () => {
    for (const key of Object.keys(this.state.errors)) {
      if (this.state.errors[key].length > 0) return true;
    }
    return false;
  };

  insertTestData = () => {
    this.setState({
      info: {
        mapName: 'Mapa sytuacyjna',
        scale: '1:1000',
        colour: 'czerwony',
        roadNr: '1/111',
        parcelTown: 'Warszawa',
        parcelDecNr: 'KW1/111',
        parcelStreet: 'Testowa',
        parcelMapNr: 'AAAA12345',
        parcel2Town: 'Warszawa',
        parcel2Street: 'Testowa2',
        parcel2MapNr: 'bbb12345',
        parcel2DecNr: 'KW011101' },
    });
  };

  postValidation = () => {
    const hasFieldErrors = this.haseErrors();
    if (this.state.selectedParcels.length === 0) {
      this.setState({
        errorText: 'Nie wybrano działki ewidencyjnej. Prosimy o wskazanie działki',
        errorTitle: 'Błędnie wypełniony formularz',
        showError: true,
      });

      return;
    }
    if (this.state.selectedParcels2.length === 0) {
      this.setState({
        errorText: 'Nie wybrano działki ewidencyjnej. Prosimy o wskazanie działki',
        errorTitle: 'Błędnie wypełniony formularz',
        showError: true,
      });

      return;
    }
    if (hasFieldErrors) {
      this.setState({
        errorText: 'Uzupełnij pola obowiązkowe.',
        errorTitle: 'Błędnie wypełniony formularz.',
        showError: true,
      });
      return;
    }

    if (!hasFieldErrors) {
      this.props
        .runService(this.props.serviceInfo.eservice.shortName, this.props.district, {
          dzialki: this.state.selectedParcels,
          selectedParcels: this.state.selectedParcels,
          selectedParcels2: this.state.selectedParcels2,
          info: this.state.info,
          user: {
            ...this.props.serviceInfo.user,
          },
          shortName: this.props.serviceInfo.eservice.shortName,
          urzad: this.props.districts[this.props.prefix],
        })
        .then(resp => {
          window.location.href = `${this.nextStep}${resp.jobId}`;
        });
    }
  };

  startService = () => {
    this.validate(null, null, this.postValidation);
  };

  render() {
    const isMobile = this.state.isMounted && isMobileView(window);
    const isTablet = this.state.isMounted && isTabletView(window);
    return (
      <div style={{ paddingTop: '20px' }}>
        <h3 style={{ textAlign: 'center' }}>
          {this.props.serviceInfo.eservice.title}
        </h3>
        <PersonalDataContainer userData={this.props.serviceInfo.user ? this.props.serviceInfo.user : null} />
        <GrayPanel
          title={'1. Informacja o położeniu nieruchomości'}
        >
          { renderHelpDesc(isMobile, isTablet) }
          <CustomizedMap
            serviceType={this.props.serviceInfo.eservice.shortName}
            setParcels={this.setParcels}
            setSelectDzialki={this.setSelectDzialki}
            selectedParcels={this.state.selectedParcels}
            obreby={this.props.serviceInfo.precints}
            district={this.props.districts[this.props.prefix]}
            prefix={this.props.prefix}
            mapState={this.props.mapstates[0]}
            settings={this.props.serviceInfo.eservice.mapConfig}
            dokumentType={this.props.serviceInfo.eservice}
          />
          <DecisionContainer
            title={''}
            data={this.state.info}
            errors={this.state.errors}
            formDict={ParcelTypeDict}
            onChange={e => this.onChange(e, 'info')}
          />
        </GrayPanel>
        <GrayPanel
          title={'2. Informacja o położeniu nieruchomości w gminie'}
        >
          <CustomizedMap
            serviceType={this.props.serviceInfo.eservice.shortName}
            setParcels={this.setParcels2}
            setSelectDzialki={this.setSelectDzialki}
            selectedParcels={this.state.selectedParcels2}
            obreby={this.props.serviceInfo.precints}
            district={this.props.districts[this.props.prefix]}
            prefix={this.props.prefix}
            mapState={this.props.mapstates[0]}
            settings={this.props.serviceInfo.eservice.mapConfig}
            dokumentType={this.props.serviceInfo.eservice}
          />
          <DecisionContainer
            title={''}
            data={this.state.info}
            errors={this.state.errors}
            formDict={Parcel2TypeDict}
            onChange={e => this.onChange(e, 'info')}
          />
        </GrayPanel>
        <DecisionContainer
          title={'3. Informacje o załączniku'}
          data={this.state.info}
          errors={this.state.errors}
          formDict={InfoTypeDict}
          onChange={e => this.onChange(e, 'info')}
        />
        <ModalAlert
          title={this.state.errorTitle}
          bodyText={this.state.errorText}
          show={this.state.showError}
          name="errorModal"
          onHide={this.onHide}
        />

        {/* BUTTONS */}
        <div className="row mobile-row">
          <div className="col-sm-12">
            <PowrotDoListyEuslug position="left" prefix={this.props.prefix} />
            <EmptyFileDownloader position="left" prefix={this.props.prefix} serviceType={this.props.serviceInfo.eservice.shortName} />
            <button
              type="submit-lg"
              className={this.props.isDisabled ? 'btn btn-primary disabled' : 'btn btn-primary'}
              style={{ float: 'right', marginRight: '15px', ...btnStyle }}
              onClick={() => this.setState({ progress: 0 }, () => this.startService())}
            >
              Uruchom
            </button>
            {_.includes(this.props.serviceInfo.user.roles, 'superadmin') ? (
              <button
                type="submit-lg"
                className="btn btn-success"
                style={{ float: 'right', marginRight: '15px', ...btnStyle }}
                onClick={this.insertTestData}
              >
                Insert Test Data
              </button>
            ) : null}
            <button
              type="submit-lg"
              className="btn btn-default"
              style={{ float: 'right', marginRight: '15px', ...btnStyle }}
              onClick={history.goBack}
            >
              Anuluj
            </button>
          </div>
        </div>
      </div>
    );
  }
}

ObciazanieNieruchomosci.propTypes = {
  serviceInfo: PropTypes.object,
  district: PropTypes.string,
};

const mapState = state => ({
  current_service: state.eservices.current,
  districts: state.district.districts
});

const mapDispatch = {
  runService,
};

export default withStyles(pans)(
  connect(
    mapState,
    mapDispatch,
  )(ObciazanieNieruchomosci),
);



// WEBPACK FOOTER //
// src/routes/eservices/ObciazanieNieruchomosci.js